import { render } from "./Styleguide-Multilingual.vue?vue&type=template&id=31a793d7"
import script from "./Styleguide-Multilingual.vue?vue&type=script&lang=js"
export * from "./Styleguide-Multilingual.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__